export const ORDERS_PAGE_STORAGE_KEY = 'ordersPage';
const LEGACY_COLUMN_ORDER_STORAGE_KEY = 'provider.orders.detailsColumnOrder';
const ORDERS_VIEW_TYPES = new Set(['orders', 'details', 'board']);

export const DETAILS_COLUMNS = [
  { id: 'order', label: 'Заказ', className: 'orders-page-itemId' },
  { id: 'product', label: 'Товар', className: 'orders-page-detailsProduct' },
  { id: 'quantity', label: 'Кол-во', className: 'orders-page-detailsQty' },
  { id: 'price', label: 'Сумма', className: 'orders-page-itemTotal' },
  { id: 'customer', label: 'Клиент', className: 'orders-page-itemCustomer' },
  { id: 'phone', label: 'Телефон', className: 'orders-page-detailsPhone' },
  { id: 'comment', label: 'Комментарий', className: 'orders-page-detailsComment' },
  { id: 'payment', label: 'Оплата', className: '' },
  { id: 'status', label: 'Статус', className: '' },
];

export const DETAILS_COLUMN_IDS = DETAILS_COLUMNS.map((column) => column.id);
export const DETAILS_COLUMN_BY_ID = Object.fromEntries(
  DETAILS_COLUMNS.map((column) => [column.id, column])
);

export function normalizeDetailsColumnOrder(value) {
  if (!Array.isArray(value) || value.length === 0) return [...DETAILS_COLUMN_IDS];
  const seen = new Set();
  const next = [];
  value.forEach((id) => {
    if (!DETAILS_COLUMN_BY_ID[id] || seen.has(id)) return;
    seen.add(id);
    next.push(id);
  });
  return next.length > 0 ? next : [...DETAILS_COLUMN_IDS];
}

export function normalizeOrdersViewType(value) {
  return ORDERS_VIEW_TYPES.has(value) ? value : 'orders';
}

function readLegacyColumnOrder() {
  try {
    const raw = localStorage.getItem(LEGACY_COLUMN_ORDER_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return null;
    return normalizeDetailsColumnOrder(parsed);
  } catch (_) {
    return null;
  }
}

export function readOrdersPageState() {
  try {
    const raw = localStorage.getItem(ORDERS_PAGE_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        return {
          viewType: normalizeOrdersViewType(parsed.viewType),
          columnOrder: normalizeDetailsColumnOrder(parsed.columnOrder),
        };
      }
    }
  } catch (_) {
    // fall through to the legacy column list
  }

  const legacyOrder = readLegacyColumnOrder();
  const state = {
    viewType: 'orders',
    columnOrder: legacyOrder || [...DETAILS_COLUMN_IDS],
  };
  if (legacyOrder) {
    writeOrdersPageState(state);
    try {
      localStorage.removeItem(LEGACY_COLUMN_ORDER_STORAGE_KEY);
    } catch (_) {
      // ignore quota / private mode
    }
  }
  return state;
}

function writeOrdersPageState(state) {
  try {
    localStorage.setItem(ORDERS_PAGE_STORAGE_KEY, JSON.stringify({
      viewType: normalizeOrdersViewType(state?.viewType),
      columnOrder: normalizeDetailsColumnOrder(state?.columnOrder),
    }));
  } catch (_) {
    // ignore quota / private mode
  }
}

export function readOrdersViewType() {
  return readOrdersPageState().viewType;
}

export function writeOrdersViewType(viewType) {
  const current = readOrdersPageState();
  writeOrdersPageState({
    viewType,
    columnOrder: current.columnOrder,
  });
}

export function readDetailsColumnOrder() {
  return readOrdersPageState().columnOrder;
}

export function writeDetailsColumnOrder(order) {
  const current = readOrdersPageState();
  writeOrdersPageState({
    viewType: current.viewType,
    columnOrder: order,
  });
}

export function allDetailsColumnsForPicker(visibleOrder = readDetailsColumnOrder()) {
  const visibleSet = new Set(visibleOrder);
  const hiddenIds = DETAILS_COLUMN_IDS.filter((id) => !visibleSet.has(id));
  return [...visibleOrder, ...hiddenIds]
    .map((id) => DETAILS_COLUMN_BY_ID[id])
    .filter(Boolean);
}
